import React from 'react';

const SearchBar = ({
  searchTerm,
  setSearchTerm,
  sources,
  filterSource,
  setFilterSource,
  dateFilter,
  setDateFilter,
  selectedEtat,
  setSelectedEtat,
  etatsLead
}) => {
  return (
    <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
      {/* Champ de recherche */}
      <div className="md:col-span-1">
        <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">
          Rechercher
        </label>
        <input
          type="text"
          id="search"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-emerald-500 focus:border-emerald-500"
        />
      </div>

      {/* Filtre Fournisseurs (Sources) */}
      <div>
        <label htmlFor="fournisseur" className="block text-sm font-medium text-gray-700 mb-1">
          Fournisseurs
        </label>
        <select
          id="fournisseur"
          value={filterSource}
          onChange={(e) => setFilterSource(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-emerald-500 focus:border-emerald-500"
        >
          <option value="">Tous les fournisseurs</option>
          {sources.map((source, index) => (
            <option key={index} value={source}>
              {source}
            </option>
          ))}
        </select>
      </div>

      {/* Filtre État du lead */}
      <div>
        <label htmlFor="etat" className="block text-sm font-medium text-gray-700 mb-1">
          État du lead
        </label>
        <select
          id="etat"
          value={selectedEtat}
          onChange={(e) => setSelectedEtat(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-emerald-500 focus:border-emerald-500"
        >
          {etatsLead.map((etat) => (
            <option key={etat} value={etat}>
              {etat}
            </option>
          ))}
        </select>
      </div>
      
      {/* Filtre Date */}
      <div>
        <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
          Date
        </label>
        <select
          id="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-emerald-500 focus:border-emerald-500"
        >
          <option value="Tous">Toutes les dates</option>
          <option value="Aujourd'hui">Aujourd'hui</option>
          <option value="7 derniers jours">7 derniers jours</option>
          <option value="15 derniers jours">15 derniers jours</option>
          <option value="Dernier mois">Dernier mois</option>
        </select>
      </div>
    </div>
  );
};

export default SearchBar;